// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 252) return "static/chunks/252-0d4d25d1217bcc42.js";
	// return url for filenames based on template
	return "static/chunks/" + ({"185":"0f4d73bd","515":"b56200f9"}[chunkId] || chunkId) + "." + {"185":"219b543506ee202f","515":"55f5bbcbf315e0b2","739":"ac008bf25dbb4076","800":"07a8b3e1c4f23408","892":"e7e08f289e92a0ad","898":"57b98baae44099d2"}[chunkId] + ".js";
};